import { DoorType } from './door-type';
import { DoorHanding } from './door-handing';
import { DoorSize } from './door-size';
import { ILaborCallout, LaborCallout } from './labor-callout';
import { IMaterialCallout, MaterialCallout } from './material-callout';

export interface IDoorAssessment {
    id: string;
    doorType: DoorType;
    handing: DoorHanding;
    size: DoorSize;
    cutdownRequired: boolean;
    alias: string;
    photoIds: string[];
    laborScope: ILaborCallout[];
    materials: IMaterialCallout[];
    existingDoorPresent: boolean;
}


export class DoorAssessment implements IDoorAssessment {
    public id: string = '';
    public doorType: DoorType = DoorType.Indeterminate;
    public handing: DoorHanding = DoorHanding.Unspecified;
    public size: DoorSize = DoorSize.Indeterminate;
    public cutdownRequired: boolean = false;
    public alias: string = '';
    public photoIds: string[] = [];
    public laborScope: ILaborCallout[] = [];
    public materials: IMaterialCallout[] = [];
    public existingDoorPresent: boolean = false;
}


